import React from 'react';

import './Crawler.scss';

var bpfrpt_proptype_Props = {
    className: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large', 'default'])
};


var LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$size = _ref.size,
        size = _ref$size === undefined ? 'default' : _ref$size;
    return React.createElement(
        'div',
        { className: 'crawler ' + className + ' is-' + size },
        React.createElement('div', null),
        React.createElement('div', null),
        React.createElement('div', null)
    );
};

LoadingIndicator.propTypes = bpfrpt_proptype_Props;
export default LoadingIndicator;
import PropTypes from 'prop-types';
export { bpfrpt_proptype_Props };